import request from "./index";

export const VideoCallRoom = {
  Create: (data) => {
    return request.post("/api/VideoCallRoom/Create", data);
  },
  UploadRecoredFiles: (data) => {
    return request.post("/api/VideoCallRoom/UploadRecoredFiles", data);
  },
  SendVideoCallEmail: (data) => {
    return request.post("/api/VideoCallRoom/SendVideoCallEmail", data);
  },
  DownloadVideoFile: (data, config) => {
    return request.post("/api/VideoCallRoom/DownloadVideoFile", data, config);
  },
  MergeVideoFiles: (data) => {
    return request.post("/api/VideoCallRoom/MergeVideoFiles", data);
  },
};
